module.exports = __webpack_public_path__ + "img/20_90.d8725baf.png";